<template>
  <section>
    <div class="container">
      <SectionHeader title="Our Partners" />
      <InfiniteScroll @isvisible="getData" :once="true">
        <div class="grid">
          <div class="item" v-for="item in data" :key="item.name">
            <img v-lazy="item.image" :alt="item.name" />
          </div>
        </div>
      </InfiniteScroll>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      data: [],
    };
  },
  methods: {
    getData() {
      axios.get(this.$route("home.api.partners")).then((response) => {
        this.data = response.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-gap: 1rem;
  @media (max-width: 576px) {
    grid-template-columns: repeat(2, 1fr);
  }
  .item {
    box-shadow: 0 0.275rem 0.75rem -0.0625rem rgb(19 16 34 / 6%),
      0 0.125rem 0.4rem -0.0625rem rgb(19 16 34 / 3%);
    border-radius: var(--border-radius);
    background: var(--white);
    overflow: hidden;
    img {
      width: 100%;
      height: 120px;
      object-fit: contain;
      padding: 0.4rem;
      @media (max-width: 576px) {
        height: 140px;
      }
    }
  }
}
</style>